// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'vue-svgicon/dist/polyfill'
import Vue from 'vue'
import ElementUI from 'element-ui'
import App from './App'
import router from './router'
import store from './store'
import './assets/styles/element_custom.scss'
import './assets/fonts/fonts.scss'
import * as svgicon from 'vue-svgicon'
import { getParam, insertParam } from '@/helpers/URL'
import i18n from '@/lang'
import iDalgoComponents from 'idalgo-components'
import Cookies from 'js-cookie'

const products = process.env.PRODUCTS
const domain = process.env.DOMAIN

const getRedirectCookie = () => {
  const value = Cookies.get('sso_redirect', { domain })
  if (!value) { return false }
  insertParam('redirect', value)
  return value
}

/**
 * Check validity of the redirect URL (from query parameters or from cookies for SSO's callback)
 */
try {
  const redirectValue = getParam('redirect') || getRedirectCookie()
  if (!redirectValue) { throw new Error() }

  const productKeys = Object.keys(products)
  const validProductKey = productKeys.find(productKey => {
    const options = products[productKey].split(',')
    return options.find(option => redirectValue.indexOf(option) !== -1)
  })
  if (!validProductKey) { throw new Error() }
  store.commit('product/PRODUCT_UPDATED', validProductKey.toLowerCase())
  Cookies.remove('sso_redirect')

  // SSO callback's error from our Account API
  const error = getParam('error')
  if (error) {
    if (error === 'access_denied') {
      store.commit('auth/SET_LOGIN_ERROR', i18n.t('loginForm.errors.accessDenied'))
    } else {
      store.commit('auth/SET_LOGIN_ERROR', i18n.t('loginForm.errors.failed'))
    }
  }

  // SSO callback's token from our Account API
  const token = getParam('token')
  if (token) {
    store.dispatch('auth/checkToken', token)
      .then(() => {
        store.dispatch('auth/storeToken', token)
        window.location = redirectValue
      })
      .catch(() => {
        router.replace({ name: 'loginSSO', query: { redirect: redirectValue } })
      })
  }
} catch (error) {
  // if redirect URL is invalid, set one by default
  router.replace({ name: 'login', query: { redirect: Object.values(products)[0] } })
  store.commit('product/PRODUCT_UPDATED', Object.keys(products)[0].toLowerCase())
}

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(iDalgoComponents)
Vue.use(svgicon)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  i18n,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js